import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TokenServiceService} from './token-service.service';
import {AuthService} from './auth.service';
import {AuthorizationDesc} from '../models/order';
import {RequestTokenCode} from '../models/requestTokenCode';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ResponseModel} from '../models/response';
import { CONSTANTS } from '../constants/users.constants';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsService {
  visibleReturnPayMethods = new EventEmitter<boolean>();
  PERU_RED = {
    'scotiabank': 1154,
    'bbva': 370
  }
  constructor(private readonly http: HttpClient,
              private readonly tokenService: TokenServiceService,
              private readonly authService: AuthService) {
  }

  public paymentMethods(token: string) {
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/json'
    );

    return this.http.post(
      `${environment.urlglobal_api}/services/services/getMethodsPay`,
      {token},
      {headers}
    );
  }

  public uniqueMethod() {
    const request = {
      token: this.tokenService.getToken()
    };
    return this.http.post(
      `${environment.urlglobal_api}/services/services/getPaymentMethod`,
      request
    ).toPromise();
  }

   public Order({pseff = false}: { pseff?: boolean } = {}): Promise<AuthorizationDesc> {
    const request = {
      token: this.tokenService.getToken()
    };
    return this.http.post(
      `${environment.urlglobal_api}/services/checkout/getorder`,
      request
    ).toPromise().then((response: any) => {
      if (response.code === 200 || (pseff && response.desc === CONSTANTS.ORDER_NOT_FOUND )) {
        this.authService.orderID = response.order.code;
        var order = new AuthorizationDesc();
        order.OrderID = response.order.code;
        order.OrderDesc = response.order.description;
        order.OrderEmail = response.order.email ? response.order.email : '';
        this.authService.setOrderInfo(order);
        return order;
      } else {
        this.tokenService.setCodeValidToken(response.code);
        throw Error(response);
      }
    });
  }

  public callCreditRequest(requestBody: RequestTokenCode): Observable<ResponseModel> {
    const url = `${environment.urlglobal_api}/api/v3/checkout/bnpl/handlersolicitudcredito`;
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: requestBody.token
      })
    }
    return this.http.post<ResponseModel>(url, requestBody, headers).pipe(map((res) => res));
  }
  /**
   *
   * @description {validatePeruCommercialnet} Function to validate Perú methods
   * @param codeRed comercial network code
   * @returns
  */
  validatePeruCommercialnet(codeRed: number) {
    if (codeRed == this.PERU_RED.scotiabank || codeRed == this.PERU_RED.bbva) {
      return true
    }
    return false
  }
}
